<script setup>
import MobileExperienceBanner from '@/components/layout/MobileExperienceBanner.vue';
</script>

<template>
  <a class="pf-skip-link" href="#main-content">
    Skip to main content
  </a>

  <MobileExperienceBanner />

  <RouterView v-slot="{ Component }">
    <Transition name="pf-route" mode="out-in">
      <component :is="Component" />
    </Transition>
  </RouterView>
</template>
